// extracted by mini-css-extract-plugin
export const hero = "index-module--hero--39XRJ";
export const textSmall = "index-module--text-small--32jq0";
export const textLarge = "index-module--text-large--2CNDP";
export const pageSection = "index-module--page-section--7vRga";